var map = {
	"./defaultText_de.json": 57,
	"./defaultText_en.json": 58,
	"./defaultText_es.json": 59,
	"./defaultText_fr.json": 60,
	"./defaultText_it-dom.json": 61,
	"./defaultText_it.json": 62,
	"./defaultText_nl.json": 63
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;